import { useState } from "react";
import { addToReferralWaitlist, getUserMessage } from "./services/api";
import { useToast } from "./components/ToastContext";
import LoginNav from "./components/LoginNav";

const ReferralScreen = ({
  handleErrors,
  navigateTo,
  isAuthenticated,
  currentScreen,
}) => {
  const toast = useToast();
  const [step, setStep] = useState("request"); // request | done
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleReferralWaitlist = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const result = await addToReferralWaitlist(email);
      if (result.success) {
        setStep("done");
      } else {
        toast.error("We couldn't add you to the waitlist. Please try again.");
        handleErrors("Error adding to referral waitlist", result.error);
      }
    } catch (error) {
      toast.error(getUserMessage(error));
      handleErrors("Error adding to referral waitlist", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-loading-color flex flex-col" style={{ height: "100vh" }}>
      {!isAuthenticated && (
        <LoginNav navigateTo={navigateTo} currentScreen={currentScreen} />
      )}
      <div className="flex-1 flex items-center justify-center py-8 px-4">
        <div className="max-w-3xl w-full text-center">
          {step === "request" && (
            <>
              <h1 className="applicant-theme-text">
                Opt in to our HQ Referral Network!
              </h1>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "1.15rem",
                  lineHeight: 1.65,
                  maxWidth: "36rem",
                  margin: "0 auto 1.0rem",
                }}
              >
                Our referral network is designed to incentivise anyone looking
                for a referral for a job, or wanting to refer others at their
                job and help them out.
              </p>
              <div className="horizontal-line" />
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="px-4 py-3 text-center font-bold text-lg text-indigo-600"></th>
                    <th className="px-4 py-3 text-center font-bold text-lg text-indigo-600">
                      Referring user gets
                    </th>
                    <th className="px-4 py-3 text-center font-bold text-lg text-indigo-600">
                      Referred user gets
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-4 py-3 text-center font-bold text-lg text-indigo-600">
                      A referral link is used
                    </td>
                    <td className="px-4 py-3 text-center font-semibold rounded-md table-cell text-lg">
                      1 month off Starter Tier
                    </td>
                    <td className="px-4 py-3 text-center font-semibold rounded-md table-cell text-lg">
                      —
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-center font-bold text-lg text-indigo-600">
                      Referred user lands a job
                    </td>
                    <td className="px-4 py-3 text-center font-semibold rounded-md table-cell text-lg">
                      1 month off Pro Tier
                    </td>
                    <td className="px-4 py-3 text-center font-semibold rounded-md table-cell text-lg">
                      1 month off Starter Tier
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="horizontal-line mb-6" />
              <label className="text-gray-600">
                Please enter your email to join our referral waitlist:
              </label>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-indigo-500"
              />
              <button
                onClick={handleReferralWaitlist}
                disabled={isLoading}
                className="buttons-indigo w-full"
                style={{
                  padding: "0.7rem 1.25rem",
                  borderRadius: "999px",
                  border: "none",
                  background: "linear-gradient(135deg, #402c7a, #826dc0)",
                  fontWeight: 700,
                  fontSize: "0.9rem",
                  marginBottom: "0.5rem",
                  transition: "opacity 0.15s",
                }}
              >
                {isLoading ? "Joining..." : "Join Referrals Waitlist"}
              </button>
            </>
          )}

          {step === "done" && (
            <>
              <h2 className="page-header text-center mb-2">
                Referral Waitlist
              </h2>
              <p className="text-sm text-gray-500 text-center mb-2">
                You have been added to our referral waitlist! You will be
                informed and prioritized on our referral program.
              </p>
              <button
                onClick={() => navigateTo("login")}
                disabled={isLoading}
                className="buttons-indigo w-full"
              >
                Back to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReferralScreen;
